import React from 'react'
import { Box, Typography, Pill } from 'components'
import { makeStyles, Chip } from '@material-ui/core'
import { useHistory } from 'react-router-dom'

const useStyles = makeStyles(theme => ({
  sectionContainer: {
    backgroundColor: 'white',
    border: '1px solid #DDD',
    borderRadius: 10,
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2)
  },
  heading: {
    fontWeight: '600',
    marginBottom: theme.spacing(1)
  },
  programChip: {
    margin: theme.spacing(0.5),
    backgroundColor: theme.palette.grey[100],
    '& .MuiChip-label': {
      fontSize: '0.85rem',
      fontWeight: 400,
      color: theme.palette.text.primary
    }
  },
  programsContainer: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  noPrograms: {
    fontSize: '0.9rem',
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(1)
  }
}))

export default function FreelancerAlumniSection({ freelancer, onEdit: propOnEdit }) {
  const classes = useStyles()
  const history = useHistory()
  
  // If onEdit is provided as a prop, use it. Otherwise, redirect to programs edit route
  const onEdit = propOnEdit;
  
  // Get programs from the freelancer object
  const programs = freelancer.programs || []
  
  return (
    <Box className={classes.sectionContainer}>
      <Typography variant="h5" className={classes.heading}>
        Alumni
      </Typography>
      
      {programs.length > 0 ? (
        <Box className={classes.programsContainer}>
          {programs.map((program, index) => (
            <Chip
              key={program.id || `program-${index}`}
              label={program.name}
              className={classes.programChip}
            />
          ))}
        </Box>
      ) : (
        <Typography variant="body2" className={classes.noPrograms}>
          No programs listed
        </Typography>
      )}
      
      {onEdit && (
        <Box mt={2}>
          <Pill size="small" onClick={onEdit}>
            {programs.length > 0 ? 'Edit Programs' : 'Add Programs'}
          </Pill>
        </Box>
      )}
    </Box>
  )
}
